export class Student {
  email: string;
  name: string;
  firstName: string;
  lastName: string;
  requestKey: string;
  avatarUrl: string;
  initials: string;

  constructor() {
    this.email = '';
    this.name = '';
    this.firstName = '';
    this.lastName = '';
    this.requestKey = '';
    this.avatarUrl = '';
    this.initials = '';
  }

  public setInitials(): void {
    this.initials =`${this.firstName.charAt(0)}${this.lastName.charAt(0)}`;
  }
  public setRequestKey(requestKey: string): void {
    this.requestKey = requestKey;
  }
  public setFirstName(firstName: string): void {
    this.firstName = firstName;
    this.setInitials();
  }
  public setLastName(lastName: string): void {
    this.lastName = lastName;
    this.setInitials();
  }
  public getName(): string {
    return this.name;
  }

  public setName(name: string): void {
    this.name = name;
  }

  public getInitials(): string {
    return this.initials;
  }

  public getInitialsUpperCase(): string {
    return this.initials.toUpperCase();
  }

  public getInitialsLowerCase(): string {
    return this.initials.toLowerCase();
  }

  public getRequestKey(): string {
    return this.requestKey;
  }

  public setStudent(student: {
    email: string;
    name: string;
    firstName: string;
    lastName: string;
    requestKey: string;
    avatarUrl: string;
  }) {
    this.email = student.email;
    this.name = student.name;
    this.firstName = student.firstName;
    this.lastName = student.lastName;
    this.requestKey = student.requestKey;
    this.avatarUrl = student.avatarUrl;
    this.setInitials();
  }

  public clearStudent() {
    this.email = '';
    this.name = '';
    this.firstName = '';
    this.lastName = '';
    this.requestKey = '';
    this.avatarUrl = '';
    this.initials = '';
  }

}
